module.exports = __webpack_public_path__ + "static/media/JAGUARDOPEDAL.a0f47039.jpeg";